import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';

import './index.scss';

const styles = bemGenerator('category-information');

const CategoryInformation = props => {
  const { t, market } = useContext(AppContext);

  if (!market.modules.categoryInfo.enabled) {
    return null;
  }

  return (
    <div className={styles.block}>
      {props.statistics &&
        t('category', 'product-list.product-and-store-count', {
          products: props.statistics.productsCount,
          stores: props.statistics.storesCount,
        })}
      <p>{t('category', 'product-list.rank-information')}</p>
    </div>
  );
};

const { shape, number } = PropTypes;

CategoryInformation.propTypes = {
  statistics: shape({
    productsCount: number.isRequired,
    storesCount: number.isRequired,
  }),
};
CategoryInformation.defaultProps = {
  statistics: undefined,
};

export default memo(CategoryInformation);
